/**
 * useAnalyticsEvent — Hook léger pour enregistrer des événements de
 * rétention (J1/J7/J30, dashboard_opened, intent_handled, post_published,
 * review_replied, profile_view, completion_step).
 *
 * Stratégie :
 * - On envoie POST /api/reseau/analytics/track (déjà existant) avec
 *   `event_type` + `metadata`. Le serveur garantit l'exclusion des
 *   utilisateurs `is_demo=true` des KPI publics agrégés.
 * - Tolérant aux échecs : aucun toast utilisateur, aucun blocage UI.
 * - Pas de PII côté metadata : on ne passe jamais d'email, de nom, ni
 *   le contenu d'une intention ou d'une note.
 *
 * Usage :
 *   const track = useAnalyticsEvent();
 *   useEffect(() => { track('cockpit_opened'); }, [track]);
 */
import { useCallback } from 'react';
import api from './api';

export default function useAnalyticsEvent() {
    return useCallback((event_type, metadata = {}) => {
        if (!event_type) return;
        // Anti-PII filter (defensive)
        const safe = {};
        Object.keys(metadata).forEach((k) => {
            const v = metadata[k];
            if (v == null) return;
            if (typeof v === 'string' && /@|\+33|06\s?\d|07\s?\d/.test(v)) return;
            if (typeof v === 'object') return; // refuse objects to avoid PII leak
            safe[k] = v;
        });
        try {
            api.post('/reseau/analytics/track', { event_type, metadata: safe })
               .catch(() => { /* silently ignore */ });
        } catch {
            /* never bubble up */
        }
    }, []);
}
